export default __webpack_public_path__ + "static/media/marshmello-album.8643c9dd.png";